import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

import { Dropdown } from '.'
import useCachedGetData from 'Hooks/useCachedGetData.js'

export const SdsLanguageDropdown = (props) => {
  const intl = useIntl()
  const [isLoading, langList] = useCachedGetData('/rapi/sds/sdsLangList', [], [intl.locale])
  const [options, setOptions] = useState([])

  const defaultLabel = props.defaultLabel ? props.defaultLabel : intl.formatMessage({ id: 'sds.select_language' })

  useEffect(() => {
    setOptions([{ label: defaultLabel, value: null }, ...langList])
  }, [langList, intl, defaultLabel])

  return <Dropdown style={{ maxWidth: '200px' }} options={options} disabled={isLoading}
                   appendTo={document.body} {...props} />
}
